const LAST_LEAGUE_REQUEST_KEY = 'lastLeagueRequestDate';

// Зберігаємо дату останнього запиту
const setLeagueRequestUntilEndOfDay = (): void => {
  const now = new Date();
  const data = {
    lastRequestDate: now.getTime(), // Зберігаємо час виконання запиту
  };

  localStorage.setItem(LAST_LEAGUE_REQUEST_KEY, JSON.stringify(data));
};

// Перевіряємо, чи можна виконувати запит
const shouldMakeLeagueRequest = (): boolean => {
  const storedData = localStorage.getItem(LAST_LEAGUE_REQUEST_KEY);

  if (!storedData) {
    return true;
  }

  try {
    const data = JSON.parse(storedData);
    const now = new Date();
    const lastRequestDate = data.lastRequestDate
      ? new Date(data.lastRequestDate)
      : null;

    if (lastRequestDate) {
      const todayStart = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
      );
      const lastRequestDayStart = new Date(
        Date.UTC(
          lastRequestDate.getUTCFullYear(),
          lastRequestDate.getUTCMonth(),
          lastRequestDate.getUTCDate(),
        ),
      );

      if (lastRequestDayStart.getTime() === todayStart.getTime()) {
        return false;
      }
    }

    return true; // Дозволяємо запит, якщо день не збігається
  } catch (error) {
    console.error('Error parsing stored data:', error);

    return true; // Дозволяємо запит у разі помилки
  }
};

export { setLeagueRequestUntilEndOfDay, shouldMakeLeagueRequest };
